import React, { useState, useEffect} from "react";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

import { connect, useDispatch} from "react-redux";
import { useParams, withRouter,useHistory, Link,} from "react-router-dom";
import { contactsUpdate, contactsDelete } from "../../../store/contacts/actions";
import { getContactsRead } from "../../../helpers/backend";

import ComponentsMantenimiento from "../../../components/Common/ComponentsMantenimiento";

const ContactsDetails = (props) => {
const param = useParams();
const dispatch= useDispatch();
const str = param.id; 
const history= useHistory();
const contactoId = Number(str);
const user = JSON.parse(localStorage.getItem("user"));
const groups =String(user.groups);


const [showAlert, setShowAlert] = useState(false)
console.log(props)
    const getData = async (contactoId) => {
      const response = await getContactsRead(contactoId);
      const data = response.data;
      
      setFormData({
        id:data.id,
        first_name: data.first_name,
        last_name: data.last_name,
        contactType: data.contactType,
        documentType: data.documentType,
        documentNumber: data.documentNumber,
        gender:data.gender,
        birthdate: data.birthdate,
        city:data.city,
        razon_social:data.razon_social,
        persona_contacto:data.persona_contacto,
        tipo_cliente:data.tipo_cliente,
        barrio_localidad:data.barrio_localidad,
        cargo:data.cargo,
        username:data.username
 

      });
    };




      
    const [formData, setFormData] = useState({
      id:"",
      first_name:"",
      last_name:"",
      contactType:"",
      documentType:"",
      documentNumber:"",
      gender:"",
      birthdate:"",
      city: "",
      razon_social:"",
      persona_contacto:"",
      tipo_cliente:"",
      barrio_localidad:"",
      cargo:"",
      username:""



 });

 const {  
  id,
  first_name, 
  last_name, 
  contactType,
  documentType,  
  documentNumber, 
 
  city, 
  razon_social,
  persona_contacto,
  tipo_cliente,
  barrio_localidad,
  cargo,
  username


} =
   formData;

  useEffect(() => {
    getData(contactoId);

  },[contactoId]);
  


 const onChange = (e) => {
  const uppercaseValue = e.target.value.toUpperCase()
  setFormData({ ...formData, [e.target.name]: uppercaseValue });
 };



 const onSubmit = (e) => {
   e.preventDefault();
   dispatch(contactsUpdate( contactoId , formData ));
   setShowAlert(true)
  };


 const deleteContact = (e,id) => {
  e.preventDefault();
  dispatch(contactsDelete(id))
 }
 

  

 
 const redirect = () => {

  history.push("/contacts");
  };

  return (
    <React.Fragment>

      <ComponentsMantenimiento
      showAlert={showAlert}
      ></ComponentsMantenimiento>


      {props.contactsDeleted ? (
 <SweetAlert
 title="Hecho!"
 success
 timeout={1000}
 showConfirm={false}
 onConfirm={() => {
  redirect();
 }}
>
 Se ha borrado el contacto Correctamente
</SweetAlert>
) : null}
   
            <Link
              className ="btn btn-info btn-sm mb-2 "
              to="/contacts">
                Volver
              </Link>{"  "}
           <Card> 


           

              
             

        {groups.includes("SuperAdmin") || groups.includes("Supervisor") ||  groups.includes( "Operador") || groups.includes("Crear y modificar Cliente") ? (
              <CardBody>
                <Form className="form-control needs-validation" onSubmit={onSubmit}>   



                          

                                    {/* Razon Social y Persona Contacto */}
                                    <Row>
                    <Col lg={6} className="mb-3">                    
                      <Label
                        for="razon_social"
                        className="form-label"
                      >
                        Razon Social
                      </Label>
                      <Input
                        id="razon_social"
                        name="razon_social"
                        type="text"
                        onChange={onChange}
                        value={razon_social}
                        valid={props.error.razon_social
                          ? true
                          : props.contactsCreated && false
                        }
                        invalid={
                          props.error
                            ? props.error.razon_social
                              ? true
                              : false
                            : false
                        }
                      />



                      <FormFeedback>{props.error.razon_social}</FormFeedback>


                      </Col>
                      <Col lg={6} className="mb-3">                    
                      <Label
                        for="username"
                        className="form-label"
                      >
                        Usuario
                      </Label>
                      <Input 
                        id="username"
                        name="username"
                        type="email"
                        onChange={onChange}
                        value={username}
                        valid={props.error.username
                          ? true
                          : props.contactsCreated && false
                        }
                        invalid={
                          props.error
                            ? props.error.username
                              ? true
                              : false
                            : false
                        }
                      />
                      <FormFeedback>{props.error.username}</FormFeedback>
                
                    </Col>           
          
                    

                    
                                     </Row>
                                    {/* Persona COntacto y cargo */}
                                     <Row>
                                     <Col lg={6} className="mb-3">                    
                      <Label
                        for="persona_contacto"
                        className="form-label"
                      >
                        Persona Contacto
                      </Label>
                      <Input 
                        id="persona_contacto"
                        name="persona_contacto"
                        type="text"
                        onChange={onChange}
                        value={persona_contacto}
                        valid={props.error.persona_contacto
                          ? true
                          : props.contactsCreated && false
                        }
                        invalid={
                          props.error
                            ? props.error.persona_contacto
                              ? true
                              : false
                            : false
                        }
                      />
                      <FormFeedback>{props.error.persona_contacto}</FormFeedback>
                
                                     </Col>  

                                        <Col lg={6} className="mb-3">                    
                                          <Label
                                            for="cargo"
                                            className="form-label"
                                          >
                                            Cargo
                                          </Label>
                                          <Input 
                                            id="cargo"
                                            name="cargo"
                                            type="text"
                                            onChange={onChange}
                                            value={cargo}
                                            valid={props.error.cargo
                                              ? true
                                              : props.contactsCreated && false
                                            }
                                            invalid={
                                              props.error
                                                ? props.error.cargo
                                                  ? true
                                                  : false
                                                : false
                                            }
                                          />
                                          <FormFeedback>{props.error.cargo}</FormFeedback>
                                    
                                        </Col>  

                                     </Row>
             

                                     {/* Nombres y Apellidos */}
                                      <Row>
                                        <Col lg={6} className="mb-3">                    
                                          <Label
                                            for="first_name"
                                            className="form-label"
                                          >
                                            Nombres
                                          </Label>
                                          <Input 
                                            id="first_name"
                                            name="first_name"
                                            type="text"
                                            onChange={onChange}
                                            
                                            
                                            value={first_name}
                                            
                                          />

                                        </Col>                  
                                        <Col lg={6}  className="mb-3">                    
                                          <Label
                                            for="apellido"
                                            className="form-label"
                                          >
                                            Apellidos
                                          </Label>
                                          <Input
                                            id="last_name"
                                            name="last_name"
                                            type="text"
                                            onChange={onChange}
                                          
                                            value={last_name}
                                                              
                                            
                                          />
                                          <FormFeedback>{props.error.last_name}</FormFeedback>
                                        
                                        </Col>
                                      </Row>


                                        {/* tipo de COntacto y tipo identificacion  */}
                                      
                                        <Row>
                                          <Col lg={6} className="mb-3">
                                            <Label
                                              for="contactType"
                                              className="form-label"
                                            >
                                            Tipo de Contacto
                                            </Label>

                                          <select
                                                  className="form-select"
                                                  id="contactType"
                                                  name="contactType"
                                                  value={contactType}                            
                                                  onChange={onChange}
                                                  >
                                                <option value ="PERSONA NATURAL">
                                                    PERSONA NATURAL
                                                  </option>
                                                  <option value ="PERSONA JURIDICA">
                                                  PERSONA JURIDICA
                                                  </option>
                                                
                                                  <option value ="OTRO">
                                                  OTRO
                                                  </option>
                                          </select>
                                                  
                                              
                                          </Col>
                                          <Col lg={6} className="mb-3">
                                            <Label
                                              for="contactType"
                                              className="form-label"
                                            >
                                            Tipo de identificación
                                            </Label>
                                            <select
                                                  className="form-select"
                                                  id="documentType"
                                                  name="documentType"
                                                  value={documentType}                            
                                                  onChange={onChange}
                                                  >
                                                  <option value ="CEDULA">
                                                  CEDULA CIUDADANIA
                                                  </option>
                                                  <option value ="PASAPORTE">
                                                  PASAPORTE
                                                  </option>
                                                  <option value ="CEDULA_EXTRANJERIA">
                                                  CEDULA DE EXTRANJERIA
                                                  </option>
                                                  <option value ="NIT">
                                                  NIT
                                                  </option>
                                                  <option value ="OTRO">
                                                  Otro
                                                  </option>
                                          </select>
                                          </Col>
                                        </Row>



                                                {/* Documento  y Ciduad*/}
                                          <Row>
                                            <Col lg={6} className="mb-3">
                                              <Label
                                                for="documentNumber"
                                                className="form-label"
                                              >
                                                Documento
                                              </Label>
                                              <Input
                                                id="documentNumber"
                                                name="documentNumber"
                                                type="text"
                                                onChange={onChange}
                                                value={documentNumber}
                                                valid={props.error.documentNumber
                                                  ? true
                                                  : props.contactsCreated && false
                                                }
                                                invalid={
                                                  props.error
                                                    ? props.error.documentNumber
                                                      ? true
                                                      : false
                                                    : false
                                                }
                                              />
                                              <FormFeedback>{props.error.documentNumber}</FormFeedback>
                                            </Col>

                                            <Col lg={6} className="mb-3">
                                              <Label
                                                for="city"
                                                className="form-label"
                                              >
                                                Cuidad
                                              </Label>
                                              <Input
                                                id="city"
                                                name="city"
                                                type="text"
                                                onChange={onChange}
                                                value={city}
                                                valid={props.error.city
                                                  ? true
                                                  : props.contactsCreated && false
                                                }
                                                invalid={
                                                  props.error
                                                    ? props.error.city
                                                      ? true
                                                      : false
                                                    : false
                                                }
                                              />
                                              <FormFeedback>{props.error.city}</FormFeedback>
                                            </Col>
                                    
                                          </Row>

                 

                 {/* TIpo de CLiente */}
                 <Row>

                   <Col lg={6} className="mb-3">
                      <Label
                        for="tipo_cliente"
                        className="form-label"
                      >
                      Tipo de Cliente
                      </Label>

                    <select
                            className="form-select"
                            id="tipo_cliente"
                            name="tipo_cliente"
                            value={tipo_cliente? tipo_cliente:"SELECCIONE"}                            
                            onChange={onChange}
                            >
                           
                           <option value ="SELECCIONE">
                            SELECCIONE
                            </option>
                            <option value ="CLIENTE ANTIGUO">
                            CLIENTE ANTIGUO
                            </option>
                            <option value ="CLIENTE NUEVO">
                              CLIENTE NUEVO
                            </option>
                    </select>
                    </Col>

                    <Col lg={6} className="mb-3">
                      <Label
                        for="barrio_localidad"
                        className="form-label"
                      >
                        Barrio o Localidad
                      </Label>
                      <Input
                        id="barrio_localidad"
                        name="barrio_localidad"
                        type="text"
                        onChange={onChange}
                        
                     
                        value={barrio_localidad} 
                        valid={props.error.barrio_localidad
                          ? true
                          : props.contactsCreated && false
                        }
                        invalid={
                          props.error
                            ? props.error.barrio_localidad
                              ? true
                              : false
                            : false
                        }
                      />
                      <FormFeedback>{props.error.city}</FormFeedback>
                    </Col>
                  </Row>
                  


                 
    
                  <Row className="col-lg-12 justify-content-center mt-3 mb-3">
                    <Col md={1}>
                   
                      <Button color="primary" type="submit">
                        Actualizar
                      </Button>
                    </Col>
                    <Col md={1}>
                   
                      <Button color="danger" type="button"
                       onClick={(e)=> deleteContact(e,id)}
                       >
                        Eliminar
                      </Button>
                    </Col>
                  </Row>     
        
                </Form>
              </CardBody>
              ):               
           
           
           
           
           
           <CardBody>
              <Form className="form-control needs-validation">    
                
                        {/* Nombres y Apellidos */}
                <Row>
                  <Col lg={6} className="mb-3">                    
                    <Label
                      for="first_name"
                      className="form-label"
                    >
                      Nombres
                    </Label>
                    <Input 
                      id="first_name"
                      name="first_name"
                      type="text"
                      onChange={onChange}
                      value={first_name}
                      disabled
                    />

                  </Col>                  
                  <Col lg={6}  className="mb-3">                    
                    <Label
                      for="apellido"
                      className="form-label"
                    >
                      Apellidos
                    </Label>
                    <Input
                      id="last_name"
                      name="last_name"
                      type="text"
                      onChange={onChange}
                      value={last_name}   
                      disabled                  
                      
                    />
                    <FormFeedback>{props.error.apellido}</FormFeedback>
                  
                  </Col>
                </Row>
              
                <Row>
                  <Col lg={6} className="mb-3">
                    <Label
                      for="contactType"
                      className="form-label"
                    >
                    Tipo de Contacto
                    </Label>

                  <select
                          className="form-select"
                          id="contactType"
                          name="contactType"
                          value={contactType}                            
                          onChange={onChange}
                          disabled
                          >
                          <option value ="PERSONA NATURAL">
                            Persona Natural
                          </option>
                          <option value ="EMPRESA">
                            Empresa
                          </option>
                          <option value ="AMBOS">
                            Ambos
                          </option>
                          <option value ="OTRO">
                            Otro
                          </option>
                  </select>
                          
                      
                  </Col>
                  <Col lg={6} className="mb-3">
                    <Label
                      for="tipo_contacto"
                      className="form-label"
                    >
                    Tipo de identificación
                    </Label>
                    <select
                          className="form-select"
                          id="documentType"
                          name="documentType"
                          value={documentType}                            
                          onChange={onChange}
                          disabled
                          >
                          <option value ="CEDULA">
                          Cédula Ciudadanía
                          </option>
                          <option value ="PASAPORTE">
                          Pasaporte
                          </option>
                          <option value ="CEDULA_EXTRANJERIA">
                          Cedula de Extranjería
                          </option>
                          <option value ="Nit">
                          NIT
                          </option>
                          <option value ="OTRO">
                          Otro
                          </option>
                  </select>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} className="mb-3">
                    <Label
                      for="documentNumber"
                      className="form-label"
                    >
                      Documento
                    </Label>
                    <Input
                      id="documentNumber"
                      name="documentNumber"
                      type="text"
                      onChange={onChange}
                      value={documentNumber}
                      disabled

                    />
                  </Col>
                
                </Row>

                <Row>
                 
                  <Col lg={6} className="mb-3">
                    <Label
                      for="city"
                      className="form-label"
                    >
                      Cuidad
                    </Label>
                    <Input
                      id="city"
                      name="city"
                      type="text"
                      onChange={onChange}
                      value={city}
                      disabled
                      valid={props.error.city
                        ? true
                        : props.contactsCreated && false
                      }
                      invalid={
                        props.error
                          ? props.error.city
                            ? true
                            : false
                          : false
                      }
                    />
                    <FormFeedback>{props.error.city}</FormFeedback>
                  </Col>
                </Row>

              </Form>
              </CardBody>
 }  
            </Card>


    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, contacts, contactsUpdated , contactsDeleted} = state.Contacts;
  return { error, loading, contacts, contactsUpdated , contactsDeleted};
};
contactsUpdate.propTypes = {
  error: PropTypes.any,
  loading: PropTypes.bool,
  contactsUpdated: PropTypes.object,
  contactsDeleted: PropTypes.object,
};
export default withRouter(connect(mapStateToProps,{ contactsUpdate, contactsDelete })(ContactsDetails));